import { makeAutoObservable } from "mobx";

import { portfolioGroupsApi } from "@mr-portfolio-api/portfolio-groups-api";
import { portfoliosApi } from "@mr-portfolio-api/portfolios-api";
import type { PortfolioListItem } from "@mr-portfolio-models/portfolio";
import type { PortfolioGroupListItem } from "@mr-portfolio-models/portfolio-group";

import { AsyncResource } from "./async-resource";

/** Active portfolios and portfolio groups shared by the navigation, dashboard and portfolio pickers. */
export class PortfoliosStore {
  public readonly portfolios = new AsyncResource<PortfolioListItem[]>([]);
  public readonly portfolioGroups = new AsyncResource<PortfolioGroupListItem[]>([]);

  public constructor() {
    makeAutoObservable(this);
  }

  public get activePortfolios(): PortfolioListItem[] {
    const activePortfolios = this.portfolios.data.filter((portfolio) => !portfolio.isArchived);

    return activePortfolios;
  }

  public findPortfolio(portfolioId: number): PortfolioListItem | null {
    const foundPortfolio = this.portfolios.data.find((portfolio) => portfolio.portfolioId === portfolioId) ?? null;

    return foundPortfolio;
  }

  public findPortfolioGroup(portfolioGroupId: number): PortfolioGroupListItem | null {
    const foundPortfolioGroup = this.portfolioGroups.data.find((portfolioGroup) => portfolioGroup.portfolioGroupId === portfolioGroupId) ?? null;

    return foundPortfolioGroup;
  }

  public async loadPortfolios(): Promise<void> {
    await this.portfolios.load((signal) => portfoliosApi.getPortfolios(false, signal));
  }

  public async loadPortfolioGroups(): Promise<void> {
    await this.portfolioGroups.load((signal) => portfolioGroupsApi.getPortfolioGroups(signal));
  }
}
